import * as querystring from "../../util/querystring";
import React, { Component } from 'react';
import decode from 'jwt-decode';
import { Form, Icon, Input, Button, notification } from 'antd';
import CAFFENIO_black from '../../assets/images/CAFFENIO_black.svg';
import ANDATTI_black from '../../assets/images/ANDATTI_black.svg';
import Auth from '../../services/Auth'
import { CAFFENIO_AUTH_PSW_RESTORE, CAFFENIO_AUTH_ID, CAFFENIO_AUTH_URL } from '../../constants';
import './Login.css'
import UsuariosRequest from '../../services/Usuarios';
import { DecryptToken } from "../../services/DecryptToken";
class Login extends Component {
    state = {
        loading: false,
        intentos: 0
    }

    /**
     * Función que carga los datos
     */
    componentDidMount() {
        // document.body.style.backgroundSize = "cover";
        // document.body.style.backgroundColor = "rgb(247, 247, 247)";
        // document.body.style.backgroundRepeat = "no-repeat";

        if (this.userIsLoggedIn()) {
            // Si ya hay un token guardado, se eliminan los query params
            this.clearParams();
        } else {
            // Si no, se parsean los queryparams para seguir con el flujo
            this.parseParams();
        }
    }

    /**
     * Función que se ejecuta cuando se salen del componente
     */
    componentWillUnmount() {
        document.body.style.backgroundImage = null;
        document.body.style.backgroundSize = null;
    }

    /**
     * Función que se ejecuta cuando hay un error
     * @param: type. valor de la notificación
     * @return: nada.
     */
    openNotificationWithIcon = (type) => {
        notification[type]({
            message: 'Error al iniciar sesión',
            description: 'Por favor, ingrese un usuario y/o contraseña válidos.',
        });
    };

    /**
     * Función que se ejecuta cuando da clic en aceptar
     * @param: e. valor del formulario 
     * @return: nada.
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true }, () => {
                    Auth.login(values.userName, values.password)
                        .then(response => {
                            let token = response.data.access_token;
                            let decodedToken = decode(token);
                            let today = new Date();
                            localStorage.setItem("expires_in", (today.getTime() / 1000) + response.data.expires_in)
                            localStorage.setItem("token", token);
                            localStorage.setItem("tokenExpiration", decodedToken.exp);
                            localStorage.setItem("role", decodedToken.role);
                            localStorage.setItem("id_user", decodedToken.uid);
                            localStorage.setItem("name", decodedToken.fullname);
                            UsuariosRequest.CrearUsuariosAuth().then(response => {
                                window.location.reload()
                            }).catch(err => {
                                this.openNotificationWithIcon("error")
                                this.setState({ loading: false, intentos: (this.state.intentos + 1) })
                            });
                        }).catch(err => {
                            this.openNotificationWithIcon("error")
                            this.setState({ loading: false, intentos: (this.state.intentos + 1) })
                        })
                })
            }
        });
    }

    /**
     * Función que se ejecuta cuando se reintenta
     * iniciar sesión.
     */
    retry = () => {
        this.setState({ intentos: 0 })
    }

    //#region Funciones de utilidad para la implementación del login en el front de CaffenioAuth
    /**
     * Revisa si el usuario ha hecho login
     */
    userIsLoggedIn = () => {
        const token = localStorage.getItem("token")
        const expiration = localStorage.getItem("tokenExpiration");

        if (!token || !expiration) {
            return false;
        }

        const now = Math.floor(Date.now() / 1000); // tiempo actual en segundos
        if (now >= expiration) {
            // Token expirado → limpiar storage y devolver false
            localStorage.clear();
            return false;
        }

        return true;
    }

    /**
     * Elimina los queryparams de la url
     */
    clearParams = () => {
        if (window.history.pushState) {
            window.history.pushState({}, null, window.location.origin + window.location.pathname)
        }
    }

    parseParams = () => {
        const parsedParams = this.decodeParams() || {};
        const applicationToken = parsedParams.applicationToken || null;

        if (applicationToken && !this.state.loading) {
            // Si hay un application token es que el usuario viene de CaffenioAuth
            this.setState({ loading: true });
            DecryptToken.decryptToken(applicationToken).then(response => {
                if (response && response.data && response.data.token) {
                    this.saveToken(response.data.token, () => {
                        this.setState({ loading: false });
                        this.clearParams();
                        window.location.reload();
                    });
                }
                else {
                    this.setState({ loading: false });
                }
            }).catch(err => {
                console.error(err);
                this.setState({ loading: false });
            })
        } else if (!this.state.loading) {
            // En caso contrario, se redirecciona a Caffenio Auth
            this.loginWithCaffenioAuth();
        }
    }

    /**
     * Busca el parámetro "payload" en los queryparams y lo decodifica a un objeto.
     */
    decodeParams = () => {
        try {
            const parsedParams = querystring.parse(document.location.search.replace('?', ''));
            if (parsedParams && parsedParams.payload) {
                const decodedPayload = atob(parsedParams.payload);
                return querystring.parse(decodedPayload);
            }
        } catch {
            console.error("Error al parsear payload.");
        }
        return {};
    }

    /**
     * Guarda el token en local storage para validar al usuario
     */
    saveToken = (access_token, callback) => {
        if (access_token) {
            localStorage.setItem("token", access_token);
            let decodedToken = decode(access_token);
            let today = new Date();
            
            localStorage.setItem("expires_in", (today.getTime() / 1000) + decodedToken.exp)
            localStorage.setItem("tokenExpiration", decodedToken.exp || "");
            localStorage.setItem("role", decodedToken.role || "");
            localStorage.setItem("id_user", decodedToken.uid || "");
            localStorage.setItem("name", decodedToken.fullname || "");
            localStorage.setItem("permissions", decodedToken.permissions || "");
            

            // Callback de pedido sugerido
            UsuariosRequest.CrearUsuariosAuth().then(response => {
                callback()
            }).catch(err => {
                this.openNotificationWithIcon("error")
                this.setState({ loading: false, intentos: (this.state.intentos + 1) })
            });
        }
    }

    loginWithCaffenioAuth = () => {
        if (!this.state.loading) {
            const params = {
                applicationId: CAFFENIO_AUTH_ID,  // id de la aplicación
                applicationName: 'Pedido Sugerido',  // nombre de la aplicación
            }
            const payload = {
                payload: btoa(querystring.encode(params)),
            }
            window.location.replace(`${CAFFENIO_AUTH_URL}/?${querystring.encode(payload)}`);
        }
    }
    //#endregion

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                {/* <div>
                    <div className="loginWrapper">
                        <p style={{ fontSize: "20px", color: "#000", textAlign: "center", fontWeight: 600 }}>Pedido Sugerido</p>
                        <Form onSubmit={this.handleSubmit} className="login-form">
                            <Form.Item className="deleteRequiredStyle" label="Usuario o correo electrónico">
                                {getFieldDecorator('userName', {
                                    rules: [{ required: true, message: 'Por favor, ingrese su usuario o correo electrónico.' }],
                                })(
                                    <Input size="large" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Usuario / correo electrónico" />
                                )}
                            </Form.Item>
                            <Form.Item label="Contraseña">
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: 'Por favor, ingrese su contraseña.' }],
                                })(
                                    <Input size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Contraseña" />
                                )}
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    size="large"
                                    htmlType="submit"
                                    className="btnLogin"
                                    loading={this.state.loading}
                                    block
                                >
                                    Accede
                                </Button>
                            </Form.Item>
                        </Form>
                        <div className="link">
                            <a href={CAFFENIO_AUTH_PSW_RESTORE} target="_blank" rel="noopener noreferrer">¿Ha olvidado su contraseña?</a>
                        </div>
                    </div>
                    <div style={{ display: "grid", placeItems: "center", paddingTop: "25px" }}>
                        <Logos />
                    </div>
                </div>  */}
            </div>
        );
    }
}

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(Login);
const Logos = props => {
    return (
        <figure style={{ height: "50px" }}>
            <img className="logo" src={CAFFENIO_black} alt="CAFFENIO" style={{padding: "10px"}} />
            &nbsp; &nbsp;
            <img className="logo" src={ANDATTI_black} alt="ANDATTI" style={{paddingBottom: "13px"}} />
        </figure>
    )
}

export default WrappedNormalLoginForm;